<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer019">
<p class="Title ParaOverride-1" id="_idParaDest-1">Praise for WHEN YOU WENT AWAY</p>
<p class="praise">“Lou Aronica writes with deep sensitivity of the power of love to transform and heal in the face of overwhelming tragedy. A lovely read.”</p>
<p class="praise-att">—#1 <span class="CharOverride-1">New York Times </span>bestselling author Susan Wiggs</p>
<p class="praise">“Nicholas Sparks fans will rejoice to hear there’s a new male author on the scene who writes beautifully about love and emotionally charged relationships. Tears of sadness and joy go hand in hand in this immensely satisfying story. Outstanding!”</p>
<p class="praise-att">—<span class="CharOverride-1">R</span><span class="CharOverride-1">T Book Reviews</span></p>
<p class="praise">“A gem. I couldn’t put it down. The characters are people I’d like to know.”</p>
<p class="praise-att">—Peggy Webb, author of the Southern Cousins Mystery Series</p>
<p class="praise">“<span class="CharOverride-1">When You Went Away</span> is a very powerful tale full of laughter, tears, and romantic moments that keep you enthralled with the authors voice. I think every reader will fall a little in love with both this outstanding author as well as this amazing character!”</p>
<p class="praise-att">—Coffee Time Romance</p>
<p class="praise">“I truly loved this story. It is so well-written that it’s hard to keep yourself separate from the fictional characters. I absolutely recommend this book and plan to read every other work written by this author. Triple-A reading!”</p>
<p class="praise-att">—Fresh Fiction</p>
<p class="praise">“<span class="CharOverride-1">When You Went Away </span>really surprised me with how much I enjoyed reading this book. Gerry and Reese stole a place in my heart.”</p>
<p class="praise-att">—Cheryl’s Book Nook</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// When_You_Went_Away.vue?3554a481